export const LOCATION_TAB_NAME = 'Location'

export const EXCLUDE_REMOTE_TAB_NAMES = [LOCATION_TAB_NAME]
